var confirmationFunc: (...args: any) => any;
var confirmationFuncArgs: any;

function initialiseConfirmationBox() {
    let confirmationBox = document.getElementById("confirmation-box") as HTMLDialogElement;
    let confirmationBoxClose = document.getElementById("confirmation-close") as HTMLElement & SVGElement;
    let confirmationBoxYes = document.getElementById("confirmation-yes") as HTMLButtonElement;
    let confirmationBoxNo = document.getElementById("confirmation-no") as HTMLButtonElement;
    // Add lots of sentry logging
    confirmationBoxClose.addEventListener("click", () => {
        try {
            confirmationBox.close();
        } catch (e) {
            console.log("Failed to close confirmation box");
            console.log(confirmationBox);
            throw e;
        }
    });
    confirmationBoxNo.addEventListener("click", () => {
        try {
            confirmationBox.close();
        } catch (e) {
            console.log("Failed to close confirmation box");
            console.log(confirmationBox);
            throw e;
        }
    });
    confirmationBox.addEventListener("click", function(e) {
        if (e.target == this) {
            try {
                confirmationBox.close();
            } catch (e) {
                console.log("Failed to close confirmation box");
                console.log(confirmationBox);
                throw e;
            }
        }
    });
    confirmationBoxYes.addEventListener("click", () => {confirmationBox.close(); confirmationFunc(...confirmationFuncArgs);});
}


export function generateConfirmationBox(title: string, description: string, func: (...args: any) => any, ...funcArgs: any) {
    return () => {
        let confirmationBox = document.getElementById("confirmation-box") as HTMLDialogElement;
        let confirmationBoxTitle = document.getElementById("confirmation-title") as HTMLHeadingElement;
        let confirmationBoxDescription = document.getElementById("confirmation-description") as HTMLParagraphElement;

        confirmationBoxTitle.innerHTML = title;
        confirmationBoxDescription.innerHTML = description;

        confirmationFunc = func;
        confirmationFuncArgs = funcArgs;
        confirmationBox.showModal();
    }
}

initialiseConfirmationBox();
